module.exports = __webpack_public_path__ + "img/check-list-inactive.cfb3d9a9.svg";